<div class="chip-input-wrapper" [ngClass]="{ disabled: formDisabled }">
   <mat-form-field class="flex-full">
      <mat-label>Department</mat-label>
      <mat-chip-grid #chipList [formControl]="departmentChipsControl" [required]="required">
         @for (value of displayValues; track value; let i = $index) {
         <mat-chip-row [selectable]="false" [removable]="true" (removed)="removeValue(value)"
            ><span class="chip-label" [matTooltip]="value.department?.name">{{ value.department?.name }}</span>
            <mat-icon matChipRemove>cancel</mat-icon>
         </mat-chip-row>
         }
         <input
            autocomplete="off"
            #departmentInput
            type="text"
            [formControl]="departmentInputControl"
            [lcsSingleSelect]="departmentSelect"
            name="department-filter"
            [allowManualInput]="true"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="true"
            (matChipInputTokenEnd)="add($event)"
            (blur)="removeErrors()"
            ndtDepartmentSelect
            [openPanelOnFocus]="true"
            [accountId]="accountId"
            [placeholder]="departmentInputControl.enabled ? 'Search' : ''"
         />
      </mat-chip-grid>
      @if (departmentChipsControl.hasError('inactiveDepartment')) {
      <mat-error>Cannot add an existing department that is inactive.</mat-error>
      } @if (departmentChipsControl.hasError('privilegeError')) {
      <mat-error>User does not have privileges to create a new department</mat-error>
      } @if (departmentChipsControl.hasError('tooManyDepartmentsError')) {
      <mat-error>Extension may only have a single department</mat-error>
      }
      <ndt-department-select
         #departmentSelect
         (optionSelected)="selected($event)"
         [departmentsToExclude]="displayDepartments"
      ></ndt-department-select>
   </mat-form-field>
</div>
